<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0">{{ $t("voicemail.name") }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <h3 class="mb-0">{{ this.$route.query.name }}</h3>
          </template>

          <div
            class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            "
          >
            <div class="row">
              <div class="col-md-2">
                <base-input>
                  <flat-picker
                    slot-scope="{ focus, blur }"
                    @on-open="focus"
                    @on-close="blur"
                    :config="{ allowInput: true }"
                    class="form-control datepicker"
                    v-model="start_date"
                  >
                  </flat-picker>
                </base-input>
              </div>

              <div class="col-md-2">
                <base-input>
                  <flat-picker
                    slot-scope="{ focus, blur }"
                    @on-open="focus"
                    @on-close="blur"
                    :config="{ allowInput: true }"
                    class="form-control datepicker"
                    v-model="end_date"
                  >
                  </flat-picker>
                </base-input>
              </div>

              <div class="col-md-3">
                <base-input
                  v-model="keyword"
                  prepend-icon="fas fa-search"
                  :placeholder="$t('search')"
                ></base-input>
              </div>

              <div class="col-md-5">
                <base-button type="info" @click="handleSearch"
                  >{{ $t("search") }}</base-button
                >
              </div>
            </div>
          </div>
          <div
            div
            class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            "
          >
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>

              <el-table-column>
                <div slot-scope="{ $index, row }" class="d-flex">
                  
                  <audio controls="controls" controlsList="nodownload" autobuffer="autobuffer"  style="margin-right:5px; padding:0px; height:3em;">
                    <source :src="'data:audio/wav;base64,' + row.VoiceBaes64" />
                  </audio>

                  <base-button
                      class="edit"
                      type="warning"
                      size="sm"
                      icon
                      @click="handleDownload(row)"
                    >
                    <i class="text-dtac-bt fa fa-download"></i>
                      {{ $t("download") }}
                    </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            "
          >
            <div class="" v-if="total != 0">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
                <span v-if="selectedRows.length">
                  - &nbsp; &nbsp; {{ selectedRows.length }}
                  {{ $t("row_select") }}
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
              v-if="total != 0"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    ...mapGetters({
      isCorporateAdmin: "Auth/isCorporateAdmin",
      isDtacAdmin: "Auth/isDtacAdmin",
      isReadOnly: "Auth/isReadOnly",
      tableData: "Voicemail/getData",
    }),
    tableColumns: function () {
      return [
        {
          prop: "CallerNumber",
          label: this.$t("voicemail.caller"),
          minWidth: 30,
          sortable: false,
        },
        {
          prop: "CalledNumber",
          label: this.$t("voicemail.called"),
          minWidth: 30,
        },
        {
          prop: "VoiceRecordDate",
          label: this.$t("voicemail.date"),
          minWidth: 30,
        },
      ];
    },
  },
  data() {
    return {
      start_date: "",
      end_date: "",
      keyword: "",
      selectedRows: [],
    };
  },
  mounted() {
    this.clearData();
    swal.fire({
      title: this.$t(`processing`),
      type: "info",
      showCancelButton: true,
      showConfirmButton: false,
      cancelButtonText: this.$t(`close`),
    });

    swal.showLoading()

    this.syncData({
      enterpriseID: this.$route.query.id,
    }).then((res)=>{
      swal.close()
      this.handleSearch()
    }).catch((err)=>{
      swal.fire({
        title: this.$t(`errors.msw.voicemail_failed`),
        icon: "error",
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: this.$t("close"),
      });
    })

    // this.listData()
  },
  methods: {
    ...mapActions({
      listData: "Voicemail/listData",
      syncData: "Voicemail/syncData",
      clearData: "Voicemail/clearData",
    }),
    handleSearch() {
      let params = {
        start_date: this.start_date,
        end_date: this.end_date,
        keyword: this.keyword,
        enterpriseID: this.$route.query.id,
      };
      this.listData(params);
    },
    handleDownload(row){
      const linkSource = `data:audio/wav;base64,${row.VoiceBaes64}`;
      const downloadLink = document.createElement("a");
      let fileName = `${row.VoiceRecordDate}_${row.CallerNumber}_${row.CalledNumber}.wav`;

      fileName = fileName.replaceAll(" ","")
      fileName = fileName.replaceAll(":","")
      fileName = fileName.replaceAll("-","")

      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();

    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
